export const FILE_REPORT_MODE = {
  pdf: 'pdf',
  xlsx: 'xlsx',
};
